import { render, staticRenderFns } from "./stats-card.vue?vue&type=template&id=db50fbf4&scoped=true&"
import script from "./stats-card.vue?vue&type=script&lang=ts&"
export * from "./stats-card.vue?vue&type=script&lang=ts&"
import style0 from "./stats-card.vue?vue&type=style&index=0&id=db50fbf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db50fbf4",
  null
  
)

export default component.exports